<template>
  <div>
    <Head title="Cuentas" />

    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center mb-8">
        <h1 class="text-3xl font-bold">Cuentas</h1>
      </div>

      <div class="bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 sm:px-6">
          <div class="flex justify-between items-center">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Listado de Cuentas
            </h3>
            <div class="flex space-x-4">
              <input
                type="text"
                v-model="filters.search"
                placeholder="Buscar..."
                class="rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              />
              <select
                v-model="filters.plan"
                class="rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              >
                <option value="">Todos los planes</option>
                <option value="free">Free</option>
                <option value="entrepreneur">Entrepreneur</option>
                <option value="sme">SME</option>
                <option value="enterprise">Enterprise</option>
              </select>
            </div>
          </div>
        </div>

        <div class="border-t border-gray-200">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plan</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuarios</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha de Creación</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="account in filteredAccounts" :key="account.id">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-gray-900">{{ account.name }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm text-gray-500">{{ account.email }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span 
                    :class="{
                      'bg-gray-100 text-gray-800': account.plan === 'free',
                      'bg-blue-100 text-blue-800': account.plan === 'entrepreneur',
                      'bg-purple-100 text-purple-800': account.plan === 'sme',
                      'bg-green-100 text-green-800': account.plan === 'enterprise'
                    }"
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                  >
                    {{ getPlanName(account.plan) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm text-gray-500">{{ account.users.length }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm text-gray-500">{{ formatDate(account.created_at) }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div class="flex space-x-4">
                    <Link 
                      :href="`/admin/accounts/${account.id}`" 
                      class="text-indigo-600 hover:text-indigo-900"
                    >
                      Ver
                    </Link>
                    <Link 
                      :href="`/admin/accounts/${account.id}/edit`" 
                      class="text-indigo-600 hover:text-indigo-900"
                    >
                      Editar
                    </Link>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  name: 'AccountsIndex',

  components: {
    Head,
    Link,
  },

  layout: Layout,

  props: {
    accounts: Array,
    filters: Object,
  },

  computed: {
    filteredAccounts() {
      return this.accounts.filter(account => {
        const matchesSearch = !this.filters.search || 
          account.name.toLowerCase().includes(this.filters.search.toLowerCase()) ||
          account.email.toLowerCase().includes(this.filters.search.toLowerCase());
        
        const matchesPlan = !this.filters.plan || account.plan === this.filters.plan;

        return matchesSearch && matchesPlan;
      });
    }
  },

  methods: {
    getPlanName(plan) {
      const plans = {
        free: 'Free',
        entrepreneur: 'Entrepreneur',
        sme: 'SME',
        enterprise: 'Enterprise'
      }
      return plans[plan] || plan
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString()
    }
  }
}
</script> 